export const FranchiseType = {
  NON_INGKA: 'NON-INGKA',
  INGKA: 'INGKA'
};
